import * as snackTypes from '@/store/modules/utils/snackbar/types';
import * as loadingTypes from '@/store/modules/utils/loading/types';

export default {
  methods: {
    $showSnackbar(msg) {
      this.$store.commit(`snackBar/${snackTypes.MUTATE_SNACKBAR}`, msg);
    },
    $startLoading() {
      this.$store.dispatch(`loading/${loadingTypes.CALL_LOADING}`, true);
    },
    $stopLoading() {
      this.$store.dispatch(`loading/${loadingTypes.CALL_LOADING}`, false);
    },
    /* Como usar este componente?
      const res = await this.$showDialog({
        title: "Política de Privacidade do Sebrae Bahia",
        message:
          "Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nullam id dolor id nibh ultricies vehicula ut id elit. Sed posuere consectetur est at lobortis. Donec ullamcorper nulla non metus auctor fringilla. Donec ullamcorper nulla non metus auctor fringilla. Maecenas faucibus mollis interdum. Donec id elit non mi porta gravida at eget metus. Etiam porta sem malesuada magna mollis euismod. Cras mattis consectetur purus sit amet fermentum. Nullam id dolor id nibh ultricies vehicula ut id elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Integer posuere erat a ante venenatis dapibus posuere velit aliquet. Nullam id dolor id nibh ultricies vehicula ut id elit. Sed posuere consectetur est at lobortis. Donec ullamcorper nulla non metus auctor fringilla. Donec ullamcorper nulla non metus auctor fringilla. Maecenas faucibus mollis interdum. Donec id elit non mi porta gravida at eget metus. Etiam porta sem malesuada magna mollis euismod. Cras mattis consectetur purus sit amet fermentum. Nullam id dolor id nibh ultricies vehicula ut id elit. Duis mollis, est non commodo luctus, nisi erat porttitor ligula, eget lacinia odio sem nec elit. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.",
        labelButton: "Entendi",
        options: {
          color: "success",
          width: "500",
          singleButton: true, // Opcional: Retira o botão CANCELAR e deixa apenas o botão do labelButton.
          titleColor: "primary--text" // Opcional: Modifica a cor do título do modal
        },
      });
    */
    async $showDialog(modalData) {
      const res = await this.$root.$confirm(modalData);
      return res;
    },
  },
};
